import { useEffect, useState } from "react";

//* delay value change
function useDebounceValue(value: string, delay: number): string {
    const [debouncedValue, setDebouncedValue] = useState(value);
  
    useEffect(() => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
  
      return () => {
        clearTimeout(handler);
      };
    }, [value, delay]);
  
    return debouncedValue;
}
  
export default useDebounceValue;